var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuTrainingZone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81714 16.3251L3.81714 21.1597M14.8171 16.3251L19.8171 21.1597M11.8171 1.82153V3.75535M11.8171 21.1597V16.3251M5.01714 16.3251H18.6171C19.7372 16.3251 20.2973 16.3251 20.7251 16.1144C21.1014 15.929 21.4074 15.6331 21.5992 15.2692C21.8171 14.8556 21.8171 14.3141 21.8171 13.231V6.84945C21.8171 5.76641 21.8171 5.22489 21.5992 4.81123C21.4074 4.44736 21.1014 4.15152 20.7251 3.96612C20.2973 3.75535 19.7372 3.75535 18.6171 3.75535H5.01714C3.89703 3.75535 3.33698 3.75535 2.90916 3.96612C2.53283 4.15152 2.22687 4.44736 2.03513 4.81123C1.81714 5.22489 1.81714 5.76641 1.81714 6.84945V13.231C1.81714 14.3141 1.81714 14.8556 2.03513 15.2692C2.22687 15.6331 2.53283 15.929 2.90916 16.1144C3.33698 16.3251 3.89703 16.3251 5.01714 16.3251Z",
    stroke: "#BBBBBB",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4221 21.0515H17.6256",
    stroke: "#BBBBBB",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7432 23.0109H17.6255",
    stroke: "#BBBBBB",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0017 25.0046H17.6255",
    stroke: "#BBBBBB",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82528 10.4685H6.78374C6.13334 10.4685 5.5859 10.9392 5.5099 11.5638L5.26296 13.5932M9.82528 10.4685C10.8738 10.2432 11.7007 9.46447 11.9612 8.45691L12.1064 7.89525M9.82528 10.4685V12.3066C9.82528 12.9998 9.82528 13.3463 9.60257 13.5617C9.37986 13.777 9.0214 13.777 8.30451 13.777C7.58762 13.777 7.22917 13.777 7.00645 13.5617C6.78374 13.3463 6.78374 12.9998 6.78374 12.3066V11.939",
    stroke: "#BBBBBB",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30465 9.18268C7.56937 9.18268 6.97331 8.60635 6.97331 7.8954C6.97331 7.18446 7.56937 6.60812 8.30465 6.60812C9.03993 6.60812 9.63599 7.18446 9.63599 7.8954C9.63599 8.60635 9.03993 9.18268 8.30465 9.18268Z",
    stroke: "#BBBBBB",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTrainingZone);
export default __webpack_public_path__ + "static/media/menu_training_zone.0734d0b10fdffcde0587cd9ed91b01a0.svg";
export { ForwardRef as ReactComponent };